import { closeWS } from "../utils/lessonws";

export default {
  data() {
    return {
      // 停止操作时间
      addictedTime: 0,
      // 定时器是否执行
      timeoutSwitch: true,
      // 防呆时长
      foolproofTime: 0,
      // 是否统计时长
      timerSwitch: null,
    };
  },
  beforeMount() {
    // is_webview 为1表示为app接入H5页面
    if (this.$route.query.is_webview == 1) {
      localStorage._user_data_id = this.$route.query.user_id;
      localStorage._user_data_company_id = this.$route.query.company_id;
      localStorage._user_data_sso_token = this.$route.query.sso_token;
      // localStorage._user_data_language = this.$route.query.language;
      if (this.$route.query.language == "en-US") {
        this.$i18n.locale = "en";
      }
      localStorage._sys_id = this.$route.query.sys_id;
      localStorage.client_version = this.$route.query.client_version;
    }
    this.getNoOperation();
  },
  methods: {
    // 触摸触发重置时间
    clickApp() {
      this.addictedTime = 0;
    },
    // 获取防呆时间
    getNoOperation() {
      this.$axios
        .post("index.php/mobile/system-setting/values", { field_name: "all" })
        .then((res) => {
          if (res.data.code === 0 && res.data.result.list.foolproof) {
            this.foolproofTime =
              parseInt(res.data.result.list.foolproof.time) * 60 + 10;
            this.timerMth();
          }
          if (
            res.data.code === 0 &&
            res.data.result.list.record_learning_time
          ) {
            this.timerSwitch = res.data.result.list.record_learning_time;
          }
        });
    },
    // 定时器
    timerMth() {
      setTimeout(() => {
        if (this.timeoutSwitch && this.addictedTime < this.foolproofTime) {
          this.addictedTime = this.addictedTime + 1;
          this.timerMth();
        }
      }, 1000);
    },
  },
  watch: {
    addictedTime(newval) {
      if (this.foolproofTime - newval > 10) {
        // this.$layer.closeAll();
      } else if (this.foolproofTime - newval <= 10) {
        // this.$toast(`这是防呆提醒,如不操作页面将在${this.foolproofTime - newval}s后关闭`)
      }
      if (newval > this.foolproofTime - 1) {
        // this.$layer.closeAll();
        closeWS();
        this.$router.go(-2);
      }
    },
  },
  beforeDestroy() {
    this.timeoutSwitch = false;
  },
};
